import type { GgxTourDefinition } from './tour-types';

export const START_03: GgxTourDefinition = {
    key: '[START-03] Understanding the custom-built Conversational AI Agent',
    route: '/home',
    estimatedMinutes: 3,
    intro: {
        headline: 'Welcome to the Conversational AI Agent tour',
        subtitle:
            'See how GGX helps you build, evaluate and deploy a custom conversational agent ' +
            'using modular pipelines and built-in evaluations.',
    },
    outro: {
        title: "That's a wrap!",
        subtitle:
            'You have seen the example conversational AI chatbot and the pipeline details GGX ' +
            'keeps for it: documentation, code, human and batch evaluations, and approvals. ' +
            'Next, try it yourself: open the Combined Customer Intent and Response Pipeline, ' +
            'look at its Dashboard for the risk metrics already computed, or start a Chat ' +
            'Session to test it live.',
        learned: [
            '**Intent Classification** works out what the user is asking.',
            '**Credit Card Response** reads customer data and writes the answer.',
            'The **Combined** pipeline stitches both into one smooth experience.',
        ],
    },
    chapters: [
        {
            name: 'The chatbot',
            blurb: 'How the example agent is built',
            icon: 'map',
            steps: [2],
        },
    ],
    steps: [
        {
            title: 'Inside the chatbot pipeline',
            whatHappens: 'the tour wraps up with a summary and ideas to try next.',
            icon: 'map',
            description:
                'See how GGX powers a customer service agent, from working out the intent of a ' +
                'question to generating the response, along with its evaluations, lineage and ' +
                'governance. Watch the video, then click Continue.',
            video: {
                src: 'https://genguardx.ai/tours/start-03-chatbot-pipeline.mp4',
                title: 'Understanding the Custom Build Conversational AI Agent',
            },
            draftCopy: true,
        },
    ],
};
